import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2a2b74d6")

_pushScopeId("data-v-2a2b74d6")
const _hoisted_1 = /*#__PURE__*/_createVNode("h2", { class: "title" }, " Uw inkomen bij arbeids­ongeschiktheid ", -1)
const _hoisted_2 = { class: "results-page" }
const _hoisted_3 = { class: "row row--no-gutter row--same-size" }
const _hoisted_4 = { class: "block results-types-explanation only-mobile" }
const _hoisted_5 = { class: "results-navigation" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Terug ")
const _hoisted_7 = { class: "results-types-explanation non-mobile" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Begin opnieuw ")
const _hoisted_9 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PdfDownloadButton = _resolveComponent("PdfDownloadButton")
  const _component_InsuranceBar = _resolveComponent("InsuranceBar")
  const _component_Controls = _resolveComponent("Controls")
  const _component_GraphBar = _resolveComponent("GraphBar")
  const _component_Button = _resolveComponent("Button")
  const _component_ExplainPayoutCategory = _resolveComponent("ExplainPayoutCategory")
  const _component_Step = _resolveComponent("Step")
  const _component_TestimonialPopupList = _resolveComponent("TestimonialPopupList")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Step, { step: _ctx.step }, {
      header: _withId(() => [
        _hoisted_1,
        _createVNode(_component_PdfDownloadButton)
      ]),
      footer: _withId(() => [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Button, {
            type: _ctx.ButtonType.Neutral,
            "icon-left": "chevron-left",
            "mobile-collapse": "",
            onClick: _ctx.prevStep
          }, {
            default: _withId(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["type", "onClick"]),
          _createVNode("div", _hoisted_7, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.activePayoutTypes, (payout) => {
              return (_openBlock(), _createBlock(_component_Button, {
                key: payout.id,
                class: payout.color,
                onClick: $event => (_ctx.explainType = payout.id),
                innerHTML: payout.name
              }, null, 8, ["class", "onClick", "innerHTML"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createVNode(_component_Button, {
            "icon-right": "chevron-right",
            onClick: _ctx.resetCalculator
          }, {
            default: _withId(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_InsuranceBar),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_Controls, { class: "col" }),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.graphs, (graph, idx) => {
              return (_openBlock(), _createBlock(_component_GraphBar, {
                key: idx,
                description: graph.name,
                "global-max": _ctx.globalMax,
                segments: graph.segments,
                class: "col",
                onSegmentClick: _cache[1] || (_cache[1] = $event => (_ctx.explainType = $event.type))
              }, null, 8, ["description", "global-max", "segments"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createVNode("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.activePayoutTypes, (payout) => {
              return (_openBlock(), _createBlock(_component_Button, {
                key: payout.id,
                class: payout.color,
                onClick: $event => (_ctx.explainType = payout.id),
                innerHTML: payout.name
              }, null, 8, ["class", "onClick", "innerHTML"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createVNode(_component_ExplainPayoutCategory, {
            modelValue: _ctx.explainType,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.explainType = $event)),
            onClose: _cache[3] || (_cache[3] = $event => (_ctx.explainType = null))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_PdfDownloadButton, { mobile: "" })
        ])
      ]),
      _: 1
    }, 8, ["step"]),
    (_ctx.isVisible)
      ? (_openBlock(), _createBlock("div", _hoisted_9, [
          _createVNode(_component_TestimonialPopupList)
        ]))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
})